import * as React from "react";
import { PanelIcon, NewChatIcon, SearchIcon } from "../../icons";
import styles from "./SessionRail.module.css";

interface Props {
	/** Icon-mark shown at the top; hovering it reveals the "open sidebar" affordance. */
	markUrl?: string;
	onExpand: () => void;
	onCreate: () => void;
}

export const SessionRail: React.FC<Props> = ({ markUrl, onExpand, onCreate }) => (
	<aside className={styles.base}>
		<button type="button" className={styles.logoBtn} onClick={onExpand} aria-label="Open sidebar">
			{markUrl && <img src={markUrl} alt="" className={styles.mark} />}
			<span className={styles.openIcon} aria-hidden>
				<PanelIcon />
			</span>
			<span className={styles.tooltip}>Open sidebar</span>
		</button>
		<button type="button" className={styles.iconBtn} onClick={onCreate} aria-label="New chat">
			<NewChatIcon />
			<span className={styles.tooltip}>New chat</span>
		</button>
		<button type="button" className={styles.iconBtn} onClick={onExpand} aria-label="Search chats">
			<SearchIcon />
			<span className={styles.tooltip}>Search chats</span>
		</button>
	</aside>
);
